import { Modal } from '@mui/material';
import React from 'react';

import { useIsFullscreenLoaderVisible } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader.store';
import { Loader } from '@/shared/components/ui/loader/loader';

import {
  ModalContentContainer,
  TransparentBackdrop,
} from './loader-modal.styled';
import { TLoaderModalProps } from './loader-modal.types';

export const LoaderModal: React.FC<TLoaderModalProps> = ({
  open,
  transparent,
  ...rest
}) => {
  const isFullscreenLoaderVisible = useIsFullscreenLoaderVisible();

  return (
    <Modal
      open={open && !isFullscreenLoaderVisible}
      slots={transparent ? { backdrop: TransparentBackdrop } : undefined}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <ModalContentContainer $transparent={transparent} tabIndex={-1}>
        <Loader {...rest} />
      </ModalContentContainer>
    </Modal>
  );
};
